<div class="book">

  <!-- ═══════════ Encabezado ═══════════ -->
  <header class="bk-head">
    <div class="bk-title">
      <h1>Beneficiarios</h1>
      <p>Tus destinatarios, agrupados por país. Cada país se registra con su propio método.</p>
    </div>
  </header>

  <!-- ═══════════ Tabs: un país por destino al que puede enviar ═══════════ -->
  <nav class="tabs" *ngIf="tabs.length">
    <button
      *ngFor="let t of tabs"
      type="button"
      class="tab"
      [class.on]="activo === t.pais"
      (click)="seleccionarTab(t.pais)">
      <img class="tflag" *ngIf="t.flag" [src]="t.flag" [alt]="t.nombre">
      <span class="tname">{{ t.nombre }}</span>
      <span class="tcur">{{ t.moneda }}</span>
      <span class="tcount" *ngIf="conteo(t.pais) !== null">{{ conteo(t.pais) }}</span>
    </button>
  </nav>

  <!-- ═══════════ Panel del tab activo ═══════════ -->
  <section class="panel" *ngIf="tabActivo as tab">

    <div class="panel-bar">
      <div class="finder">
        <input
          type="text"
          [(ngModel)]="busqueda"
          (ngModelChange)="onBusquedaChange()"
          [placeholder]="'Buscar en ' + tab.nombre + ' por nombre, banco o cuenta'">
        <button
          type="button"
          class="clear"
          *ngIf="busqueda"
          (click)="limpiarBusqueda()"
          aria-label="Limpiar búsqueda">&times;</button>
      </div>

      <!-- El botón vive en el tab y nombra su país: registra siempre ahí -->
      <button
        type="button"
        class="btn primary add"
        [disabled]="!puedeRegistrar"
        (click)="registrar()">
        <ng-container *ngIf="!registrando">+ {{ labelRegistrar }}</ng-container>
        <ng-container *ngIf="registrando">Abriendo…</ng-container>
      </button>
    </div>

    <p class="aviso" *ngIf="avisoDestinoInactivo">
      {{ tab.nombre }} no está recibiendo envíos en este momento, así que no se
      pueden registrar nuevos beneficiarios. Los que ya tenés siguen acá.
    </p>

    <p class="msg" *ngIf="cargando">Cargando beneficiarios…</p>

    <div class="alert" *ngIf="!cargando && error">
      {{ error }}
      <button type="button" class="linkbtn" (click)="cargar()">Reintentar</button>
    </div>

    <p class="msg" *ngIf="vacio">
      Todavía no tenés beneficiarios en {{ tab.nombre }}. Registrá el primero.
    </p>

    <p class="msg" *ngIf="sinResultados">
      Ningún beneficiario de {{ tab.nombre }} coincide con "{{ busqueda }}".
    </p>

    <!-- ═══ Lista ═══ -->
    <div class="rows" *ngIf="!cargando && filas.length">
      <article
        class="row"
        *ngFor="let f of filas; trackBy: trackById"
        [class.locked]="f.bloqueado"
        [class.busy]="ocupada(f)">

        <span class="avatar">{{ f.titulo.charAt(0) }}</span>

        <div class="who">
          <span class="nm">{{ f.titulo }}</span>
          <span class="sb">
            {{ f.cuenta }}
            <ng-container *ngIf="f.banco"> · {{ f.banco }}</ng-container>
          </span>
          <span class="badges">
            <span class="bb">{{ f.metodo }}</span>
            <span class="bb warn" *ngIf="f.bloqueado">No habilitado</span>
          </span>
          <span class="block" *ngIf="f.bloqueado">{{ f.motivoBloqueo }}</span>
        </div>

        <div class="acts">
          <button
            type="button"
            *ngIf="capacidades?.ficha"
            [disabled]="ocupada(f)"
            (click)="verFicha(f)">Ver</button>
          <button
            type="button"
            *ngIf="capacidades?.editar"
            [disabled]="ocupada(f) || f.bloqueado"
            (click)="editar(f)">Editar</button>
          <button
            type="button"
            class="danger"
            *ngIf="capacidades?.eliminar"
            [disabled]="ocupada(f)"
            (click)="eliminar(f)">Eliminar</button>
        </div>
      </article>
    </div>

    <p class="count" *ngIf="!cargando && filas.length">
      {{ filas.length }} {{ filas.length === 1 ? 'beneficiario' : 'beneficiarios' }}
      <ng-container *ngIf="busqueda"> de {{ total }}</ng-container>
    </p>

  </section>
</div>
